module.exports = __webpack_public_path__ + "static/img/thankyou.db55a8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thankyou.svg
// module id = V7Re
// module chunks = 1